import { css as t, createGlobalStyle as e } from "styled-components";
const a = t`
	body {
		font-size: ${({ theme: i }) => `${i.typography.fontSize}px`};
		font-family: ${({ theme: i }) => i.typography.fontFamily};
		/* color: ${({ theme: i }) => i.palette.primary.main}; */
		color: ${({ theme: i }) => i.palette.text.primary};
		/* @media (max-width: 480px) {
            overflow: hidden;
        } */
	}

	body:lang(zh-Hant) {
		font-family: ${({ theme: i }) => i.deprecated.fonts.chineseTraditional};
	}

	body:lang(zh-Hans) {
		font-family: ${({ theme: i }) => i.deprecated.fonts.chineseSimplified};
	}

	html,
	body,
	#app {
		height: 100%;
	}

	#notification-root {
		position: relative;
		z-index: 2147483647 !important;
	}

	#hubspot-messages-iframe-container {
		z-index: 2147483646 !important;
	}

	.grecaptcha-badge {
		visibility: hidden;
	}
`, n = e`
    ${a}

    //crutch, required for applications insights lib tracking
    .applications-insights-wrapper {
        display: flex;
        width: 100vw;
        height: 100%;
    }
`;
export {
  n as GlobalStyles
};
//# sourceMappingURL=global.mjs.map
